/* ZAMRI INDIA — CRO Theme JS */
(function(){
'use strict';

/* ── Mobile Nav ── */
function initNav(){
  var burger = document.querySelector('.z-nav__burger');
  var drawer = document.querySelector('.z-drawer');
  var close  = document.querySelector('.z-drawer__close');
  if(!burger||!drawer) return;
  burger.addEventListener('click',function(){ drawer.classList.add('open'); document.body.style.overflow='hidden'; });
  if(close) close.addEventListener('click',function(){ drawer.classList.remove('open'); document.body.style.overflow=''; });
  drawer.addEventListener('click',function(e){ if(e.target===drawer){ drawer.classList.remove('open'); document.body.style.overflow=''; } });
}

/* ── Accordion ── */
function initAccordions(){
  document.querySelectorAll('.z-acc__trig').forEach(function(btn){
    btn.addEventListener('click',function(){
      var body = btn.nextElementSibling;
      var open = body.classList.contains('open');
      btn.closest('.z-acc__item').parentElement.querySelectorAll('.z-acc__body.open').forEach(function(b){ b.classList.remove('open'); b.previousElementSibling.setAttribute('aria-expanded','false'); });
      if(!open){ body.classList.add('open'); btn.setAttribute('aria-expanded','true'); }
    });
  });
}

/* ── Gallery Thumbs ── */
function initGallery(){
  document.querySelectorAll('.z-pdp__thumbs').forEach(function(wrap){
    var mainImg = wrap.closest('.z-pdp__gal').querySelector('#z-main-img');
    wrap.querySelectorAll('.z-pdp__thumb').forEach(function(thumb){
      thumb.addEventListener('click',function(){
        wrap.querySelectorAll('.z-pdp__thumb').forEach(function(t){ t.classList.remove('active'); });
        thumb.classList.add('active');
        if(mainImg && thumb.dataset.src) mainImg.src = thumb.dataset.src;
      });
      thumb.addEventListener('keydown',function(e){ if(e.key==='Enter'||e.key===' '){ e.preventDefault(); thumb.click(); } });
    });
  });
}

/* ── Variant Buttons ── */
function initVariants(){
  document.querySelectorAll('.z-vars').forEach(function(wrap){
    wrap.querySelectorAll('.z-var:not(.sold-out)').forEach(function(btn){
      btn.addEventListener('click',function(){
        wrap.querySelectorAll('.z-var').forEach(function(b){ b.classList.remove('active'); });
        btn.classList.add('active');
        updatePDPFromVariant();
      });
    });
  });
  document.querySelectorAll('.z-swatches').forEach(function(wrap){
    wrap.querySelectorAll('.z-swatch').forEach(function(sw){
      sw.addEventListener('click',function(){
        wrap.querySelectorAll('.z-swatch').forEach(function(s){ s.classList.remove('active'); });
        sw.classList.add('active');
      });
    });
  });
}

function updatePDPFromVariant(){
  // Shopify variant matching — wired via data-variants JSON
  var varData = document.getElementById('z-variant-data');
  if(!varData) return;
  try {
    var variants = JSON.parse(varData.textContent);
    var selected = [];
    document.querySelectorAll('.z-var.active').forEach(function(b){ selected.push(b.dataset.value); });
    var match = variants.find(function(v){ return v.options.every(function(o,i){ return !selected[i]||selected[i]===o; }); });
    if(match){
      document.getElementById('z-variant-id').value = match.id;
      var priceEl = document.getElementById('z-pdp-price');
      var stickyEl = document.getElementById('z-sticky-price');
      var atcEl = document.getElementById('z-atc-btn');
      var formatted = '\u20b9' + (match.price/100).toLocaleString('en-IN');
      if(priceEl) priceEl.textContent = formatted;
      if(stickyEl) stickyEl.textContent = formatted;
      if(atcEl){
        atcEl.disabled = !match.available;
        if(!match.available){ atcEl.textContent = 'Sold Out'; }
        else { atcEl.innerHTML = '<i class="ti ti-shopping-bag" aria-hidden="true"></i> Add to Cart — ' + formatted; }
      }
    }
  } catch(e){}
}

/* ── Qty Stepper ── */
function initQty(){
  document.querySelectorAll('.z-qty').forEach(function(wrap){
    var dec = wrap.querySelector('[data-dec]');
    var inc = wrap.querySelector('[data-inc]');
    var val = wrap.querySelector('.z-qty__val');
    if(!dec||!inc||!val) return;
    dec.addEventListener('click',function(){ var v=parseInt(val.value); if(v>1) val.value=v-1; });
    inc.addEventListener('click',function(){ val.value=parseInt(val.value)+1; });
  });
}

/* ── Sticky ATC ── */
function initStickyATC(){
  var bar = document.getElementById('z-sticky-atc');
  var target = document.querySelector('.z-pdp__atc');
  if(!bar||!target) return;
  var observer = new IntersectionObserver(function(entries){
    bar.classList.toggle('visible', !entries[0].isIntersecting);
    bar.setAttribute('aria-hidden', entries[0].isIntersecting ? 'true' : 'false');
  },{ threshold:0 });
  observer.observe(target);
  var stickyBtn = bar.querySelector('button');
  if(stickyBtn) stickyBtn.addEventListener('click',function(){ document.getElementById('z-product-form').requestSubmit(); });
}

/* ── Cart Progress Bar ── */
function initCartProgress(){
  var bar = document.getElementById('z-prog-fill');
  var msg = document.getElementById('z-prog-msg');
  if(!bar) return;
  var subtotal = parseInt(bar.dataset.subtotal)||0;
  var threshold = 199900; // ₹1,999 in paise
  if(subtotal>=threshold){
    bar.style.width='100%';
    if(msg) msg.innerHTML='<i class="ti ti-circle-check" style="color:var(--green)"></i> You qualify for <strong>free shipping!</strong>';
  } else {
    var pct = Math.min((subtotal/threshold)*100,100);
    bar.style.width = pct+'%';
    var needed = Math.ceil((threshold-subtotal)/100);
    if(msg) msg.innerHTML='<i class="ti ti-truck" style="color:var(--gold)"></i> Add <strong>\u20b9'+needed.toLocaleString('en-IN')+'</strong> more for free shipping';
  }
}

/* ── Pay Option Select ── */
function initPayOptions(){
  document.querySelectorAll('.z-pay-opts').forEach(function(wrap){
    wrap.querySelectorAll('.z-pay-opt').forEach(function(opt){
      opt.addEventListener('click',function(){
        wrap.querySelectorAll('.z-pay-opt').forEach(function(o){ o.classList.remove('sel'); });
        opt.classList.add('sel');
        var radio = opt.querySelector('input[type=radio]');
        if(radio) radio.checked=true;
      });
    });
  });
}

/* ── Newsletter ── */
function initNewsletter(){
  var form = document.getElementById('z-nl-form');
  if(!form) return;
  form.addEventListener('submit',function(){
    var btn = form.querySelector('.z-nl__btn');
    if(btn){ btn.textContent='Subscribed \u2713'; btn.disabled=true; btn.style.background='#3B6D11'; }
  });
}

/* ── Filter Tags (collection) ── */
function initFilters(){
  document.querySelectorAll('.z-filter-tags').forEach(function(wrap){
    wrap.querySelectorAll('.z-ftag').forEach(function(tag){
      tag.addEventListener('click',function(){
        wrap.querySelectorAll('.z-ftag').forEach(function(t){ t.classList.remove('active'); });
        tag.classList.add('active');
      });
    });
  });
}

/* ── Countdown Timer (urgency) ── */
function initCountdown(){
  var el = document.getElementById('z-countdown');
  if(!el) return;
  var end = new Date().getTime() + (parseInt(el.dataset.minutes)||23)*60000;
  var iv = setInterval(function(){
    var now = new Date().getTime();
    var diff = end - now;
    if(diff<=0){ clearInterval(iv); el.textContent='Offer ended'; return; }
    var m = Math.floor((diff%(1000*60*60))/(1000*60));
    var s = Math.floor((diff%(1000*60))/1000);
    el.textContent = m+'m '+('0'+s).slice(-2)+'s';
  },1000);
}

/* ── Init ── */
document.addEventListener('DOMContentLoaded',function(){
  initNav();
  initAccordions();
  initGallery();
  initVariants();
  initQty();
  initStickyATC();
  initCartProgress();
  initPayOptions();
  initNewsletter();
  initFilters();
  initCountdown();
});
})();
